import { ElementType } from 'react';
import { FieldRenderProps } from 'react-final-form';
import { v4 } from 'uuid';

import * as Styled from './FormField.styles';

const FormField =
  <FormValue extends any = any>(AntComponent: ElementType) =>
  ({
    input,
    meta,
    label,
    thin,
    submitError,
    clearSubmitError,
    ...props
  }: FieldRenderProps<FormValue>) => {
    const submitErrorMessage = submitError?.[input.name] || '';
    const hasError = (meta.error || !!submitErrorMessage) && meta.touched;
    const isValid = meta.valid && meta.touched;

    const onChange = (e: React.FormEvent<HTMLInputElement>) => {
      if (submitErrorMessage) {
        clearSubmitError({
          ...submitError,
          [input.name]: undefined,
        });
      }
      input.onChange(e);
    };

    const id = v4();

    return (
      <Styled.FormField
        htmlFor={id}
        label={label}
        required={props.required}
        hasFeedback={hasError || isValid}
        help={hasError ? <>{meta.error || submitErrorMessage}</> : null}
        validateStatus={hasError && 'error'}
        $thin={thin}
        $tip={props.tip}
      >
        {props.tip && <p className="tip">{props.tip}</p>}
        <AntComponent {...input} {...props} id={id} onChange={onChange} />
      </Styled.FormField>
    );
  };

export default FormField;
